import { useEffect, useState } from "react";
import { useMe } from "@/data/user.ts";
import { useNavigate } from "react-router-dom";
import { useBreakpoint } from "@/utils/hooks/useBreakpoints.ts";
import { AgendaProvider } from "@/contexts/AgendaContext.tsx";
import { addDays, isBefore } from "date-fns";
import { CHANGE_EVENT_LOCAL_KEY } from "@/utils/agenda.ts";
import ROUTES from "@/config/routes.ts";
import useGlobals from "@/utils/hooks/useGlobals.ts";
import FeedbackRating from "@/components/agenda/FeedbackRating.tsx";
import MobileAgendaView from "@/components/agenda/mobile/Index.tsx";
import AgendaChangeEvent from "@/pages/agenda/ChangeEvent.tsx";
import DesktopAgendaView from "@/components/agenda/desktop/Index.tsx";

export default function Agenda() {
  const { me } = useMe();
  const isSmall = ["xs", "sm", "md"].indexOf(useBreakpoint()) !== -1;
  const navigate = useNavigate();
  const hasChangeEvent = localStorage.getItem(CHANGE_EVENT_LOCAL_KEY);
  const { setGlobalState } = useGlobals();

  const [showFeedback, setShowFeedback] = useState(false);

  useEffect(() => {
    setGlobalState("backgroundClass", "bg-brand-background");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (hasChangeEvent && isSmall) {
      navigate(ROUTES.agenda_change_event);
    }

    if (!me) return;
    const user = me.item.user;
    const kickoffDate = me.item.kickoff_date;

    const currentDate = new Date();
    const kickoffDateArray = kickoffDate.split("/");

    const popupDate = addDays(
      new Date(
        Number(kickoffDateArray[2]),
        Number(kickoffDateArray[1]) - 1,
        Number(kickoffDateArray[0]),
      ),
      45,
    );

    if (isBefore(popupDate, currentDate) && user.nps_feedback == null) {
      setShowFeedback(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasChangeEvent, isSmall, me]);

  return (
    <>
      {Boolean(hasChangeEvent && !isSmall) && <AgendaChangeEvent />}

      <div className="h-full w-full overflow-hidden !px-0 relative">
        {isSmall ? (
          <MobileAgendaView />
        ) : (
          <AgendaProvider>
            <DesktopAgendaView />
          </AgendaProvider>
        )}

        {showFeedback && <FeedbackRating setShowFeedback={setShowFeedback} />}
      </div>
    </>
  );
}
